import Expand from './behaviour-expand';
import Modal from './modal-control';
import Checkboxes from './check-all-checkboxes';
import Dropdown from './dropdown-menu';
import FormValidator from './form-validator';
import FocusOnLoad from './load-focus';
import TopicFilter from './pegasus-topicfilter';
import ENGMainNavigation from './eng-main-navigation';

const init = () => {
  // Expand and collapse (actually only used on the topics page)
  try {
    Expand.init();
  } catch (error) {
    console.error('expand not initiated', error);
  }

  // Modal management
  try {
    Modal.init();
  } catch (error) {
    console.error('modal not initiated', error);
  }

  // One checkbox to rule them all
  try {
    Checkboxes.init();
  } catch (error) {
    console.error('checkbox not initiated', error);
  }

  // Manage dropdowns
  try {
    Dropdown.init();
  } catch (error) {
    console.error('dropdown not initiated', error);
  }

  // Validate all forms, (de)activate submit button and prevent form posting
  try {
    FormValidator.init();
  } catch (error) {
    console.error('formValidator not initiated', error);
  }

  // Set focus on page load
  try {
    FocusOnLoad.init();
  } catch (error) {
    console.error('focus not initiated', error);
  }

  // Setup Search
  try {
    TopicFilter.init();
  } catch (error) {
    console.error('topicFilter not initiated', error);
  }

  try {
    ENGMainNavigation.init();
  } catch (error) {
    console.error('Error loading MainNavigation', error);
  }

  console.log('init V6');
};

document.addEventListener('DOMContentLoaded', init);
